
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/internal-ai-knowledge-base",
      function () {
        return require("private-next-pages/internal-ai-knowledge-base.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/internal-ai-knowledge-base"])
      });
    }
  